export const ROUTE_PATH_EMAIL_INBOX = '/admin/email/inbox';
export const ROUTE_PATH_EMAIL_SENT = '/admin/email/sent';
export const ROUTE_PATH_EMAIL_TRASH = '/admin/email/trash';
export const ROUTE_PATH_EMAIL_STARRED = '/admin/email/starred';
export const ROUTE_PATH_EMAIL_COMPOSE = '/admin/email/compose';
export const ROUTE_PATH_EMAIL_MESSAGE_DETAIL = '/admin/email/messages/:id';

export const inbox = ROUTE_PATH_EMAIL_INBOX;
export const sent = ROUTE_PATH_EMAIL_SENT;
export const trash = ROUTE_PATH_EMAIL_TRASH;
export const starred = ROUTE_PATH_EMAIL_STARRED;
export const compose = ROUTE_PATH_EMAIL_COMPOSE;
export const messageDetail = ROUTE_PATH_EMAIL_MESSAGE_DETAIL;
